module.exports = __webpack_public_path__ + "images/emoji/fried_shrimp.31ca0e5bbfdf9b9a29d3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/fried_shrimp.png
// module id = VjQ5
// module chunks = 2